import { useContext, useState, useEffect } from "react";

import { useNavigate, Link } from "react-router-dom";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import { IoMdInformationCircleOutline } from "react-icons/io";
import Rest from '../../../../Services/Rest';
import { GlobalInfo } from "../../../../Contexts/GlobalContext";
import Toaster from "../../../../Components/Toaster";
import Loader from "../../../../Components/Loader";
import { RequestorService } from "../../../../Services/Requestor.Service";
import TokenService from "../../../../Services/Token.service";
import { OverlayTrigger, Popover, Button, Dropdown, Form as RBForm } from "react-bootstrap";
import { getErrorMessage } from "../../../../Utils/Common";
import SampleTypeDropdown from "../../../../Components/AdministrativeSettings/SampleTypeDropdown";
import LabsMultiselectDropdown from "../../../../Components/AdministrativeSettings/LabsMultiselectDropdown";
const checkIfExists = (column, value) => {
    return Rest.post(`/user/exists`, { column, value })
        .then(response => response.data.exists)
        .catch(error => {
            console.error('Error checking if exists:', error);
            return false;
        });
};
// Validation schema using Yup
const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    middle_name: Yup.string().required('Middle Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    username: Yup.string()
        .required('User Name is required')
        .min(3, 'User Name must be at least 3 characters long')
        .matches(/^[a-zA-Z0-9]+$/, 'User Name must be alphanumeric')
        // .test('username-unique', 'Username already exists', async function (value) {
        //     if (!value) return true;
        //     const exists = await Rest.post(`/user/exists`, { 'column': 'username', 'value': value });
        //     return !exists.data.exists;
        // })
        ,

    email: Yup.string()
        .email('Invalid email format')
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
        .required('Email is required')
        // .test('email-unique', 'Email already exists', async function (value) {
        //     if (!value) return true;
        //     const exists = await Rest.post(`/user/exists`, { 'column': 'email', 'value': value });
        //     return !exists.data.exists;
        // })
        ,
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters long')
        .max(20, 'Password must not be greater than 20 characters')
        .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Must contain at least one digit')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Must contain at least one special character'),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
    phone_number: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone Number must be 10 digits')
        .required('Phone Number is required'),
    pharma_id: Yup.string().required('Pharma is required'),
    campus_id: Yup.string().required('Campus is required'),
    // gender: Yup.string().required('Gender is required'),
    // lab_id: Yup.string().required('Lab selection is required'),
    lab_id: Yup.array()
    .min(1, "Please select at least one lab") // require at least one lab
    .required("Lab is required"),
});

function AddRequestor() {


    const navigate = useNavigate();
    const { appUserIsLogin, isSidebarVisible } = useContext(GlobalInfo);

    const [labOptions, setLabOptions] = useState([]);
    const [pharmaOptions, setPharmaOptions] = useState([]);
    const [campusOptions, setCampusOptions] = useState([]);
    const [pharmaSearch, setPharmaSearch] = useState("");
    const [campusSearch, setCampusSearch] = useState("");

    const normalizeListResponse = (response) => {
        const data = response?.data || response || {};
        if (Array.isArray(data)) {
            return data;
        }
        if (Array.isArray(data.list)) {
            return data.list;
        }
        if (Array.isArray(data.data)) {
            return data.data;
        }
        return [];
    };

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const [loading, setLoading] = useState(false);
    const previousUrl = TokenService.getPrevLink();
    const [navigateToRequestor, setNavigateToRequestor] = useState(false);

    const initialValues = {
        first_name: '',
        middle_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
        confirm_password: '',
        phone_number: '',
        pharma_id: '',
        campus_id: '',
        // gender: 'XY',  // Default to 'XY'
        lab_id: [],     // Lab selection
    };
    // const [selectedLabs, setSelectedLabs] = useState([]);
    
    // const handleLabsChange = (lab, setFieldValue) => {
    //     if (selectedLabs.includes(lab)) {
    //         setSelectedLabs(selectedLabs.filter((s) => s !== lab));
    //         setFieldValue("lab_id", selectedLabs.filter((id) => id !== lab));
    //     } else {
    //         setSelectedLabs([...selectedLabs, lab]);
    //         setFieldValue("lab_id", [...selectedLabs, lab]);
    //     }
    // };
    const handleSubmit = async (values, { resetForm , setSubmitting, setFieldError }) => {
        const emailExists = await checkIfExists('email', values.email);
        if (emailExists) {
            setFieldError('email', 'Email already exists');
            setSubmitting(false);
            return;
        }

        const usernameExists = await checkIfExists('username', values.username);
        if (usernameExists) {
            setFieldError('username', 'User Name already exists');
            setSubmitting(false);
            return;
        }
        setLoading(true);
        const requestorData = {
            first_name: values.first_name,
            middle_name: values.middle_name,
            last_name: values.last_name,
            username: values.username,
            email: values.email,
            password: values.password,
            phone_number: values.phone_number,
            pharma_id: Number(values.pharma_id),
            campus_id: Number(values.campus_id),
            // gender: values.gender,
            sequence: 1,
            is_superadmin: 0,
            user_type: [2], // User type for requestor
            lab_id: values.lab_id, // Default lab ID
        };

        try {
            const data = await RequestorService.addRequestor(requestorData);
            const message = getErrorMessage(data);
            if (!data.status) {
                setToastMessage(message);
                setToastVariant('error');
            } else {
                resetForm();
                setToastMessage(data.message);
                setToastVariant('success');
                setNavigateToRequestor(true);
            }
        } catch (error) {
            setToastMessage('Failed to add requestor.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            setShowToast(true);
        }
    };

    useEffect(() => {
        if (navigateToRequestor) {
            const timer = setTimeout(() => {
                // administrative-settings/
                navigate('/admin/pharma-management',{state: {
                    toastMessage: 'Requestor added successfully!',
                    toastVariant: 'success',
                }});
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [navigateToRequestor]);

    useEffect(() => {
        const fetchLabs = async () => {
            try {
                const response = await RequestorService.getLabList();
                setLabOptions(response.labs || []);
            } catch (error) {
                console.error("Error fetching labs", error);
            }
        };
        fetchLabs();
    }, []);

    useEffect(() => {
        const fetchPharmaList = async () => {
            try {
                const payload = { limit: 1000, offset: 0, filters: [{ status: [1] }] };
                const response = await RequestorService.getPharmaList(payload);
                setPharmaOptions(normalizeListResponse(response));
            } catch (error) {
                console.error("Error fetching pharma list", error);
                setPharmaOptions([]);
            }
        };

        const fetchCampusList = async () => {
            try {
                const payload = { limit: 1000, offset: 0, filters: [{ status: [1] }] };
                const response = await RequestorService.getCampusList(payload);
                setCampusOptions(normalizeListResponse(response));
            } catch (error) {
                console.error("Error fetching campus list", error);
                setCampusOptions([]);
            }
        };

        fetchPharmaList();
        fetchCampusList();
    }, []);
    return (
        <>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">Add New Requestor</h2>
                    <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Pharma Management</Link>
                    <div className="el-bg-table el-super-admin" >
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            validateOnChange={false}
                            validateOnBlur={true}

                        >
                            {({ values, errors, touched, setFieldValue, setFieldTouched }) => {
                                const filteredPharmaOptions = pharmaOptions.filter((pharma) =>
                                    (pharma?.pharma_name || "")
                                        .toLowerCase()
                                        .includes(pharmaSearch.toLowerCase())
                                );
                                const campusOptionsForPharma = campusOptions.filter(
                                    (campus) =>
                                        !values.pharma_id ||
                                        String(campus.pharma_id) === String(values.pharma_id)
                                );
                                const filteredCampusOptions = campusOptionsForPharma.filter((campus) =>
                                    (campus?.campus_name || "")
                                        .toLowerCase()
                                        .includes(campusSearch.toLowerCase())
                                );
                                const selectedPharma = pharmaOptions.find(
                                    (pharma) => String(pharma.id) === String(values.pharma_id)
                                );
                                const selectedCampus = campusOptions.find(
                                    (campus) =>
                                        String(campus.id || campus.campus_id) ===
                                        String(values.campus_id)
                                );
                                const campusDropdownDisabled = !values.pharma_id;

                                return (
                                <Form>
                                    {/* {Object.keys(errors).length > 0 && (
                                        <div className="alert alert-danger">
                                            {Object.values(errors).map((error, index) => (
                                                <div key={index}>{error}</div>
                                            ))}
                                        </div>
                                    )} */}
                                    <div className="  mt-3 mt-md-0 col-md-12">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Select Pharma <span className="text-red">*</span></label>
                                                <Dropdown className="w-100">
                                                    <Dropdown.Toggle
                                                        variant="light"
                                                        className={`w-100 text-start form-control ${touched.pharma_id && errors.pharma_id ? "is-invalid" : ""}`}
                                                    >
                                                        {selectedPharma?.pharma_name || "Select Pharma"}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                                        <div className="px-2 py-2">
                                                            <RBForm.Control
                                                                type="text"
                                                                placeholder="Search pharma..."
                                                                value={pharmaSearch}
                                                                onChange={(e) => setPharmaSearch(e.target.value)}
                                                            />
                                                        </div>
                                                        <Dropdown.Divider />
                                                        {filteredPharmaOptions.length > 0 ? (
                                                            filteredPharmaOptions.map((pharma) => (
                                                                <Dropdown.Item
                                                                    key={pharma.id}
                                                                    onClick={() => {
                                                                        setFieldValue("pharma_id", String(pharma.id));
                                                                        setFieldTouched("pharma_id", true, false);
                                                                        setFieldValue("campus_id", "");
                                                                        setFieldTouched("campus_id", false, false);
                                                                        setCampusSearch("");
                                                                    }}
                                                                >
                                                                    {pharma.pharma_name}
                                                                </Dropdown.Item>
                                                            ))
                                                        ) : (
                                                            <p className="px-3 text-muted mb-0">No pharma found</p>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                {touched.pharma_id && errors.pharma_id && (
                                                    <div className="invalid-feedback d-block">{errors.pharma_id}</div>
                                                )}
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Select Campus <span className="text-red">*</span></label>
                                                <Dropdown className="w-100">
                                                    <Dropdown.Toggle
                                                        variant="light"
                                                        disabled={campusDropdownDisabled}
                                                        className={`w-100 text-start form-control ${touched.campus_id && errors.campus_id ? "is-invalid" : ""}`}
                                                    >
                                                        {selectedCampus?.campus_name ||
                                                            (campusDropdownDisabled ? "Select pharma first" : "Select Campus")}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                                        <div className="px-2 py-2">
                                                            <RBForm.Control
                                                                type="text"
                                                                placeholder="Search campus..."
                                                                value={campusSearch}
                                                                onChange={(e) => setCampusSearch(e.target.value)}
                                                                disabled={campusDropdownDisabled}
                                                            />
                                                        </div>
                                                        <Dropdown.Divider />
                                                        {campusDropdownDisabled ? (
                                                            <p className="px-3 text-muted mb-0">Select pharma first</p>
                                                        ) : filteredCampusOptions.length > 0 ? (
                                                            filteredCampusOptions.map((campus) => {
                                                                const campusId = campus.id || campus.campus_id;
                                                                return (
                                                                    <Dropdown.Item
                                                                        key={campusId}
                                                                        onClick={() => {
                                                                            setFieldValue("campus_id", String(campusId));
                                                                            setFieldTouched("campus_id", true, false);
                                                                        }}
                                                                    >
                                                                        {campus.campus_name}
                                                                    </Dropdown.Item>
                                                                );
                                                            })
                                                        ) : (
                                                            <p className="px-3 text-muted mb-0">No campus found</p>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                {touched.campus_id && errors.campus_id && (
                                                    <div className="invalid-feedback d-block">{errors.campus_id}</div>
                                                )}
                                            </div>
                                        </div>
                                    <div className="row  mt-md-0 ">
                                            {/* Lab Dropdown */}

                                            {/* <div className="col-md-4 " >
                                                <label htmlFor="lab_id" className="form-label">Lab<span className="text-red">*</span></label>
                                                <Field as="select" name="lab_id" className="form-control">
                                                    <option value="">Select a Lab</option>
                                                    {labOptions.map((lab) => (
                                                        <option key={lab.id} value={lab.id}>{lab.name}</option>
                                                    ))}
                                                </Field>
                                                {touched['lab_id'] && errors['lab_id'] && (
                                                    <ErrorMessage name="lab_id" component="div" className="text-danger" />
                                                )}
                                            </div> */}
                                            <div className="jb-filters el-board-table col-md-4"> 
                                                <div className="job-list-st-filter el-request-management-dropdown">
                                                <LabsMultiselectDropdown
                                                    samples={labOptions}
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                    errors={errors}
                                                    touched={touched}
                                                />
                                                </div>
                                            </div>
                                            {/* <div className="col-md-4" >
                                                <label htmlFor="lab_id" className="form-label">Lab<span className="text-red">*</span></label>
                                                <Field as="select" name="lab_id" className="form-control">
                                                    <option value="">Select a Lab</option>
                                                    {labOptions.map((lab) => (
                                                        <option key={lab.id} value={lab.id}>{lab.name}</option>
                                                    ))}
                                                </Field>
                                                {touched['lab_id'] && errors['lab_id'] && (
                                                    <ErrorMessage name="lab_id" component="div" className="text-danger" />
                                                )}
                                            </div> */}
                                        </div>
                                        <div className="row">
                                            {/* First Name, Middle Name, Last Name */}

                                            {['first_name', 'middle_name', 'last_name'].map((field) => (
                                                <div className="col-md-4" key={field}>
                                                    <label htmlFor={field} className="form-label">
                                                        {field.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}
                                                    <span className="text-red">*</span>
                                                    </label>
                                                    <Field
                                                        type="text"
                                                        name={field}
                                                        className="form-control"
                                                        maxLength={50}
                                                        onInput={(e) => {
                                                            // e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 50);
                                                            e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z]/g, '').slice(0, 50);
                                                        }}
                                                        placeholder={`Enter ${field
                                                            .replace(/_/g, ' ')
                                                            .trim()
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                                    />
                                                    {touched[field] && errors[field] && (
                                                        <ErrorMessage name={field} component="div" className="text-danger" />
                                                    )}
                                                </div>
                                            ))}

                                        </div>

                                        <div className="row">
                                            {/* Email, Phone Number, Biological Sex */}

                                            <div className="col-md-4">
                                                <label htmlFor="email" className="form-label">
                                                    Email <span className="text-red">*</span>
                                                </label>
                                               
                                                <Field
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    maxLength={50}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/\s/g, '').slice(0, 50);
                                                    }}
                                                    placeholder="Enter Email"
                                                />
                                                {touched.email && errors.email && (
                                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                                )}
                                            </div>

                                            <div className="col-md-4">
                                                <label htmlFor="phone_number" className="form-label">
                                                    Phone Number <span className="text-red">*</span>
                                                </label>
                                               
                                                <Field
                                                    type="number"
                                                    maxLength={10}
                                                    name="phone_number"

                                                    className='form-control no-arrows'
                                                    onInput={(e) => {
                                                        if (e.target.value.length > 10) {
                                                            e.target.value = e.target.value.slice(0, 10);
                                                        }
                                                    }}
                                                    placeholder="Enter Phone Number"
                                                />
                                                {touched.phone_number && errors.phone_number && (
                                                    <ErrorMessage name="phone_number" component="div" className="text-danger" />
                                                )}
                                            </div>

                                            {/* <div className="col-md-4">
                                                <label className="form-label">Biological Sex <span className="text-red">*</span></label>
                                               
                                                <div className="d-flex justify-content-between mt-4 ms-3 w-40">
                                                    {['XY', 'XX'].map((gender) => (
                                                        <div className="form-check " key={gender}>
                                                            <Field id={`biological_sex_${gender}`} type="radio" name="gender" value={gender} className="form-check-input radio-pointer" />
                                                            <label htmlFor={`biological_sex_${gender}`} className="form-check-label radio-pointer">&nbsp; {gender}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div> */}

                                        </div>

                                        <div className="row">
                                            {/* Username, Password, Confirm Password */}

                                            {['username', 'password', 'confirm_password'].map((field) => (
                                                <div className="col-md-4" key={field}>
                                                    <label htmlFor={field} className={`${field != 'password' ? 'mt-2' : ''} form-label`}>
                                                        {field.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}
                                                    <span className="text-red">*</span>
                                                    {field == 'password' && (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                overlay={
                                                                    <Popover id={`popover-${field}`}>
                                                                        <Popover.Header as="h5">Password Guidelines</Popover.Header>
                                                                        <Popover.Body>
                                                                            <ul>
                                                                                <li>At least 8 characters long</li>
                                                                                <li>At least one uppercase letter</li>
                                                                                <li>At least one number</li>
                                                                                <li>At least one special character</li>
                                                                            </ul>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <Button variant="link" className="password-info-btn p-0 m-0" style={{ fontSize: '16px' }}>
                                                                    <IoMdInformationCircleOutline />
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}
                                                    </label>
                                                    <Field
                                                        type={field.includes('password') ? 'password' : 'text'}
                                                        name={field}
                                                        className="form-control"
                                                        maxLength={50}

                                                        onInput={(e) => {
                                                            if (field.includes('password') && e.target.value.length > 20) {
                                                                e.target.value = e.target.value.slice(0, 20);
                                                            }
                                                            else if (field === 'username') {
                                                                // e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').slice(0, 50);
                                                                e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 50);
                                                            }
                                                            else {
                                                                // e.target.value = e.target.value.slice(0, 50);
                                                                e.target.value = e.target.value.replace(/\s/g, '').slice(0, 50);
                                                            }
                                                        }}

                                                        placeholder={`Enter ${field
                                                            .replace(/_/g, ' ')
                                                            .trim()
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                                    />
                                                    {touched[field] && errors[field] && (
                                                        <ErrorMessage name={field} component="div" className="text-danger" />
                                                    )}
                                                </div>
                                            ))}

                                        </div>
                                      
                                    </div>
                                    <div className="d-flex align-items-center mt-3">
                                        <button type="submit" className="el-main-button"> <span>Submit</span> </button>
                                        {/* administrative-settings */}
                                        <Link className="back-link ms-3" to="/admin/pharma-management">Close</Link>
                                    </div>
                                    {/* <div>
                                        <h3>Values</h3>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(values, null, 2)}
                                        </pre>
                                        <h3>Errors</h3>
                                        <p>Total Errors: {Object.keys(errors).length}</p>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(errors, null, 2)}
                                        </pre>      
                                    </div>  */}
                                </Form>
                                );
                            }}
                        </Formik>
                    </div>
                    <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />
                </div>
            </div>
        </>
    );
}

export default AddRequestor;
